import { render, staticRenderFns } from "./SimpleBarChart.vue?vue&type=template&id=9b646d68"
import script from "./SimpleBarChart.vue?vue&type=script&lang=js"
export * from "./SimpleBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports